export const getLocalStorage = <T>(storageKey: string): T | null => {
  const value = localStorage.getItem(storageKey);
  if (value !== null) {
    try {
      return JSON.parse(value) as T;
    } catch {
      return null;
    }
  }
  return null;
};

export const setLocalStorage = <T>(key: string, value: T): void =>
  localStorage.setItem(key, JSON.stringify(value));

export const removeLocalStorage = (key: string): void =>
  localStorage.removeItem(key);
